import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { stopEndpoint, launchEndpoint } from './actions';

export interface EndpointOperationState {
  loaded: boolean;
  success: boolean;
  message: string;
}

const initialState: EndpointOperationState = {
  loaded: false,
  success: false,
  message: ''
};

const reducer = reducerWithInitialState(initialState)
  .case(launchEndpoint.started, (state) => {
    return { ...state, loaded: false, success: false, message: ''};
  })
  .case(launchEndpoint.done, (state, param) => {
    return { ...state, loaded: true, success: param.result.success, message: param.result.message};
  })
  .case(launchEndpoint.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })
  .case(stopEndpoint.started, (state) => {
    return { ...state, loaded: false, success: false, message: ''};
  })
  .case(stopEndpoint.done, (state, param) => {
    return { ...state, loaded: true, success: param.result.success, message: param.result.message};
  })
  .case(stopEndpoint.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })
;

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/endpointOperation/reducers.ts